import { useState, useEffect } from "react";
import { Calendar, Sparkles, Star, Timer } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";

const API = process.env.REACT_APP_BACKEND_URL;

const StatsBand = () => {
  const { t } = useLanguage();
  const [liveRating, setLiveRating] = useState(null);
  const icons = [Calendar, Sparkles, Star, Timer];

  useEffect(() => {
    fetch(`${API}/api/reviews`)
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => d && d.rating && setLiveRating(Number(d.rating)))
      .catch(() => {});
  }, []);

  const items = t.stats.items.map((it) =>
    it.label === "Google" && liveRating
      ? { ...it, value: `${liveRating.toFixed(1)}★` }
      : it,
  );

  return (
    <section
      className="relative border-y border-white/10 bg-[#0d0d0d] overflow-hidden"
      data-testid="stats-band"
    >
      {/* diagonal red brushstroke */}
      <div className="absolute inset-y-0 -left-20 w-72 bg-[#e10600]/[0.07] -skew-x-12 pointer-events-none" />
      <div className="absolute inset-y-0 -right-20 w-72 bg-[#e10600]/[0.05] -skew-x-12 pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 md:py-14 grid grid-cols-2 md:grid-cols-4 gap-y-8">
        {items.map((it, i) => {
          const Icon = icons[i % icons.length];
          return (
            <div
              key={it.label}
              className={`relative px-4 md:px-8 ${
                i > 0 ? "md:border-s md:border-white/10" : ""
              }`}
              data-testid={`stat-tile-${i}`}
            >
              <div className="flex items-center gap-2 mb-3">
                <Icon className="w-3.5 h-3.5 text-[#e10600]" />
                <span className="text-[10px] tracking-[0.3em] uppercase font-display font-bold text-white/50">
                  {it.label}
                </span>
              </div>
              <p className="font-display font-black text-white text-[22px] sm:text-3xl md:text-4xl lg:text-5xl leading-none tabular-nums whitespace-nowrap">
                {it.value}
              </p>
              <p className="mt-2 text-xs md:text-sm text-white/55 leading-snug">
                {it.note}
              </p>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default StatsBand;
